import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { EXECUTION_SERVICE } from '@eggplant/api-hosts'
import type { ReactNode } from 'react'

interface Props {
  id: string
  children?: () => ReactNode
  onSuccess: () => void
}

const DeleteExecutionRequest = ({
  id,
  children,
  onSuccess
}: Props) => {
  const url = `${EXECUTION_SERVICE}/executions/${id}`

  return (
    <AuthenticatedDataRequest
      method='delete'
      onSuccess={onSuccess}
      url={url}
    >
      {children}
    </AuthenticatedDataRequest>
  )
}

export default DeleteExecutionRequest
